export function getCategoryUKGC (toBeFound, arr) {
  if (!arr || !toBeFound) {
    return null
  }
  const category = arr.find((x) => x.slug === toBeFound)
  return category?.customUKGC
}

export const getUKGCLink = (pageCategory, categoriesArray) => {
  const category = categoriesArray?.find((categoryId) => categoryId.slug === pageCategory)
  return category?.customUKGCLink
}
